export type ChipTone = 'ok' | 'warn' | 'crit' | 'info' | 'neutral';

const TONE_CLASSES: Record<ChipTone, string> = {
  ok: 'bg-green-500/10 text-green-400',
  warn: 'bg-yellow-500/10 text-yellow-400',
  crit: 'bg-red-500/10 text-red-400',
  info: 'bg-primary/10 text-primary',
  neutral: 'bg-gray-500/10 text-gray-text',
};

/**
 * Shared status pill (same look as ContentManagement's STATUS_CONFIG chips,
 * generalized so queue pages stop re-declaring per-file variants).
 */
export default function StatusChip({ label, tone }: { label: string; tone: ChipTone }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${TONE_CLASSES[tone]}`}
    >
      {label}
    </span>
  );
}
